import type { DispatcherCallbacks } from './dispatcher';
import { pickDispatcherCallbacks } from './dispatcher';
import type { RintintinBookingInitOptions } from './types';

/** Compose les callbacks utilisateur avec une action SDK après checkout-complete. */
export function mergeCheckoutCompleteCallback(
  options: RintintinBookingInitOptions,
  onSdkCheckoutComplete: () => void
): DispatcherCallbacks {
  const base = pickDispatcherCallbacks(options);
  const userCb = options.onCheckoutComplete;
  return {
    ...base,
    onCheckoutComplete: (payload) => {
      try {
        userCb?.(payload);
      } finally {
        onSdkCheckoutComplete();
      }
    },
  };
}
